export function onActivationKeyDown(action) {
  return e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
    }
  };
}
export function onPanelEscapeKeyDown(onClose) {
  return e => {
    if (e.key === 'Escape') {
      onClose();
    }
  };
}